<template>
  <div class="justify-content-center">
    <div class="mt-5 mb-2 d-flex justify-content-center">
      <div class="line"></div>
      <div style="margin-top: 0.5rem">
        <h5>
          <strong>{{ titulo }}</strong>
        </h5>
      </div>
      <div class="line"></div>
    </div>
    <b-row class="mb-3">
      <b-col></b-col>
      <b-col
        class="py-2"
        cols="md-5 sm-12"
        v-for="(item, key) in rota"
        :key="key + `multa`"
      >
        <b-card
          no-body
          img-left
          class="shadow cardServicoInterno"
          @click="clickCard(item)"
        >
          <b-card-header
            class="bg-transparent d-flex align-items-center border-0"
          >
            <font-awesome-icon
              :icon="[item.icone.tipo, item.icone.nome]"
              size="3x"
            />
          </b-card-header>

          <b-card-body>
            <b-card-title style="font-size: large">{{
              item.titulo
            }}</b-card-title>
            <b-card-sub-title style="font-size: medium; text-align: justify">{{
              item.descricao
            }}</b-card-sub-title>
          </b-card-body>
        </b-card>
      </b-col>
      <b-col></b-col>
    </b-row>
    <div class="d-flex justify-content-center">
      <div class="line"></div>
      <div style="margin-top: 0.5rem">
        <h5>
          <strong>
            SERVIÇOS OFERECIDOS NO PORTAL DE SERVIÇOS DA PREFEITURA DE BELO
            HORIZONTE</strong
          >
        </h5>
      </div>
      <div class="line"></div>
    </div>
    <b-row class="mt-3">
      <b-col
        class="py-2"
        cols="md-4 sm-12"
        v-for="(item, key) in listaUrl"
        :key="key"
        @click="clickCardServico(item)"
        :title="item.detalhe"
      >
        <b-card no-body img-left class="cardServicoExterno shadow">
          <b-card-header
            class="bg-transparent d-flex align-items-center border-0"
          >
            <font-awesome-icon :icon="['fa', item.icone]" size="3x" />
          </b-card-header>

          <b-card-body>
            <b-card-title style="font-size: large">{{
              item.titulo
            }}</b-card-title>
            <b-card-sub-title style="font-size: medium">{{
              item.subtitulo
            }}</b-card-sub-title>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import { mapMutations } from "vuex";
export default {
  name: "MenuBody",
  data() {
    return {
      titulo: "MULTA DE TRÂNSITO emitida pela Prefeitura de Belo Horizonte",
      listaUrl: [],
    };
  },
  computed: {
    rota() {
      return this.$router.options.routes.filter((item) => {
        return item.titulo && item.menu;
      });
    },
  },
  methods: {
    ...mapMutations(["setFiltroPesquisa","setResultadoPesquisa"]),

    clickCard(rota) {
      this.setFiltroPesquisa({});
      this.setResultadoPesquisa({});
      this.$router.push({ name: rota.name });
    },

    clickCardServico(item) {
      this.setFiltroPesquisa({});
      this.setResultadoPesquisa({});
      window.open(item.url, "_blank");
    },

    listar() {
      this.$api.Multa.listarUrlServico({})
        .then((response) => {
          if (response.data.success && response.data.data) {
            this.listaUrl = [];
            response.data.data.forEach((item) => {
              this.listaUrl.push(item);
            });
          }
        })
        .catch(() => {});
    },
  },

  mounted() {
    this.listar();
  },
};
</script>

<style scoped>
.card {
  cursor: pointer;
}

.card:hover {
  transform: scale(1.1);
}
.cardServicoExterno {
  border-radius: 25px;
  background-color: whitesmoke;
  border-color: whitesmoke;
  border-top: 0.2rem solid;
  border-top-color: hsl(46, 91%, 52%);
  height: 100%;
}

.cardServicoInterno {
  height: 100%;
  border-radius: 25px;
  border-color: white;
  border-top: 0.2rem solid;
  border-top-color: black;
}


</style>